<template>
    <section :class="summaryClass">
        <slot></slot>
    </section>
</template>

<script>
    export default {
        props: {
            isCompact: { type: Boolean, default: false },
        },

        computed: {
            summaryClass() {
                return {
                    summary: true,
                    'summary--is-compact': this.isCompact,
                }
            },
        },
    }
</script>
